import type { ButtonHTMLAttributes, InputHTMLAttributes, ReactNode } from 'react';

type VarianteBoton = 'primario' | 'secundario' | 'peligro' | 'contorno' | 'contornoPeligro' | 'exito';

const clasesBoton: Record<VarianteBoton, string> = {
  primario: 'bg-primary text-primary-foreground hover:opacity-90 font-bold',
  secundario: 'bg-surface text-foreground hover:opacity-80',
  peligro: 'bg-destructive text-white hover:opacity-90',
  exito: 'bg-success text-white hover:opacity-90',
  contorno: 'border border-border bg-transparent text-foreground hover:bg-surface',
  contornoPeligro: 'border border-destructive/40 bg-transparent text-destructive hover:bg-destructive/10',
};

export function Boton({
  variante = 'primario',
  grande = false,
  className = '',
  ...props
}: ButtonHTMLAttributes<HTMLButtonElement> & { variante?: VarianteBoton; grande?: boolean }) {
  return (
    <button
      className={`rounded-control px-4 ${grande ? 'min-h-(--alto-boton-principal) py-3 text-boton-principal' : 'min-h-(--alto-control) py-1.5 text-contenido'} font-semibold transition-opacity disabled:opacity-40 disabled:cursor-not-allowed ${clasesBoton[variante]} ${className}`}
      {...props}
    />
  );
}

/**
 * Abre el selector de archivos y se ve exactamente como un `Boton`. Existe porque un input de
 * archivo no se puede disparar desde un botón sin un `<label>` de por medio, y ese label necesita el
 * mismo aspecto que los botones que tiene al lado.
 */
export function BotonArchivo({
  variante = 'primario',
  children,
  className = '',
  ...props
}: InputHTMLAttributes<HTMLInputElement> & { variante?: VarianteBoton; children: ReactNode }) {
  return (
    <label
      className={`rounded-control min-h-(--alto-control) inline-flex cursor-pointer items-center px-4 py-1.5 text-contenido font-semibold transition-opacity ${clasesBoton[variante]} ${className}`}
    >
      {children}
      <input type="file" className="hidden" {...props} />
    </label>
  );
}

/** Acción en línea dentro de una tabla o una fila: «Editar», «Desactivar», «Ver». */
export function BotonEnlace({
  tono = 'info',
  children,
  ...props
}: ButtonHTMLAttributes<HTMLButtonElement> & { tono?: 'info' | 'peligro' }) {
  const tonos = { info: 'text-info', peligro: 'text-destructive' } as const;
  return (
    <button {...props} className={`${tonos[tono]} text-contenido font-semibold underline`}>
      {children}
    </button>
  );
}
